import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/intro.svg'


const _withScopeId = n => (_pushScopeId("data-v-04421078"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "main"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  draggable: "false"
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "Projděte si náš kvíz!", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "description" }, " O koloběhu vody už víte vše důležité. Nyní máte možnost si otestovat své nově nabyté znalosti v našem kvízu. Zvládnete odpovědět na všech 10 otázek správně? ", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))

import { ref } from 'vue'
import { useStore } from 'vuex'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore()

const isActive = ref(true)

const start = () => {
  store.commit('start')
  isActive.value = false
}

return (_ctx: any,_cache: any) => {
  return (isActive.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", { class: "horizontal" }, [
          _hoisted_2,
          _createElementVNode("div", { class: "info" }, [
            _hoisted_3,
            _hoisted_4,
            _createElementVNode("button", {
              class: "button solidButton",
              onClick: start
            }, "Jdeme na to")
          ]),
          _hoisted_5
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})